<template>
  <div>
    <b-form
      class="position-relative"
    >
      <b-row>
        <b-col md="12">
          <b-card
            border-variant="success"
            bg-variant="transparent"
            class="shadow-none module-card"
          >
            <b-overlay
              :show="busy"
              rounded="lg"
              opacity="0.6"
            >
              <template #overlay>
                <div class="d-flex align-items-center">
                  <b-spinner
                    small
                    type="grow"
                    variant="secondary"
                  />
                  <b-spinner
                    type="grow"
                    variant="dark"
                  />
                  <b-spinner
                    small
                    type="grow"
                    variant="secondary"
                  />

                  <!-- We add an SR only text for screen readers -->
                  <span class="sr-only">{{ $t('DEBTIA_PLEASE_WAIT_MSG') }}</span>
                </div>
              </template>
              <b-form-group
                :label="$t('DEBTIA_RECEIPIENT')"
                label-for="receipient"
              >
                <v-select
                  v-model="receipient"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="ReceipientOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="receipient"
                />
              </b-form-group>
              <b-form-group
                label-for="letter_template"
                :aria-hidden="busy ? 'true' : null"
              >
                <b-form-checkbox
                  v-model="awaitPayment"
                  checked="true"
                  class="custom-control-success"
                  switch
                >
                  {{ $t('DEBTIA_AWAIT_PAYMENT_BEFORE_CONTINUING') }}
                </b-form-checkbox>
              </b-form-group>
              <!-- <hr>
              <b-form-group
                :label="$t('DEBTIA_EMAIL_TEMPLATE_TEXT')"
                label-for="email_template"
                :aria-hidden="busy ? 'true' : null"
              >
                <v-select
                  v-model="emailTemplate"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="emailTemplateOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  :input-id="'email-template'"
                  @input="changeTemplate()"
                />
              </b-form-group> -->
              <div>
                <b-form-group
                  v-for="(data,index) in templateVariables"
                  :key="index"
                  :label="data"
                  label-for="email_template"
                  :aria-hidden="busy ? 'true' : null"
                >
                  <div :id="'div-wrapper-'+data">
                    <v-select
                      :disabled="busy"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="templateVariableOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      :input-id="'email-template-'+data"
                      :class="'email-template-'+data"
                      @input="changeVariable($event, data)"
                    >
                      <template
                        slot="option"
                        slot-scope="option"
                      >
                        <div :class="assignClass(option.value) ? 'autofik' : ''">
                          {{ option.label }}
                        </div>
                      </template>
                    </v-select>
                    <b-row
                      :id="'date-'+data"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          :label="$t('DEBTIA_SELECT_DAYS_MSG')"
                          label-for="email_template"
                        >
                          <b-form-input
                            :id="'noOfDays-'+data"
                            type="number"
                            @change="noOfDaysChange($event, data)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-form-group>
              </div>
              <hr>
              <b-form-group>
                <b-table
                  ref="roles"

                  class="position-relative"
                  :fields="fields"
                  :items="items"
                >
                  <template #cell(removeIcon)="data">
                    <b-button
                      variant="gradient-danger"
                      class="btn-icon rounded-circle"
                      size="sm"
                      @click="removeProduct(data)"
                    >
                      <feather-icon icon="Trash2Icon" />
                    </b-button>
                  </template>
                  <template #cell(name)="data">
                    <v-select
                      v-model="data.item.productId"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="data.item.name"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="products"
                      @input="getProductPrice($event, data)"
                    />
                  </template>

                  <template #cell(quantity)="data">
                    <span class="text-nowrap">
                      <b-form-input
                        v-model="data.item.quantity"
                        placeholder="Title"
                        @input="getSubTotal"
                      />
                    </span>
                  </template>

                  <template #cell(price)="data">
                    <span class="text-nowrap">{{ data.item.price * data.item.quantity }}</span>
                  </template>
                </b-table>
              </b-form-group>

              <b-form-group
                class="text-center"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle"
                  @click="addProduct"
                >
                  <feather-icon
                    icon="PlusIcon"
                  />
                </b-button>
              </b-form-group>
              <hr>
              <b-form-group>
                <div class="left">
                  <p>
                    <small>{{ $t('DEBTIA_SUBTOTAL') }}</small>
                    <br>
                    <small>VAT (25%)</small>
                    <br>
                    <small>{{ $t('DEBTIA_TOTAL') }}</small>
                  </p>
                </div>
                <div class="right">
                  <p>
                    <small>{{ subTotal }} kr.</small>
                    <br>
                    <small>{{ vat }} kr.</small>
                    <br>
                    <small>{{ total }} kr.</small>
                  </p>
                </div>
              </b-form-group>
            </b-overlay>

            <b-button
              class="emailSubmitBtn"
              variant="primary"
              type="submit"
              @click.prevent="submit"
            >
              <b-spinner
                v-if="spinnerOn"
                small
                class="mr-1"
                label="Small Spinner"
              />
              <span v-else>{{ $t('DEBTIA_SUBMIT') }}</span>
            </b-button>
            <span
              v-if="errorMsg"
              id="fieldserror"
            >{{ $t('DEBTIA_TEMPLATE_FIELDS_REQUIRED') }}</span>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BOverlay,
  BCard,
  BSpinner,
  BFormInput,
  BTable,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import axiosemailv1 from '../../../libs/axiosemailv1'
// import axiosemail from '../../../libs/axiosemail'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BOverlay,
    BSpinner,
    BCard,
    BButton,
    BFormInput,
    BTable,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      errorMsg: false,
      spinnerOn: false,
      ReceipientOptions: [
        { label: 'Creditor', value: 'debtia.receipientsClient' },
      ],
      receipient: 'debtia.receipientsClient',
      receipientVars: {
        'debtia.receipientsClient': 'debtiaReceipientsClient',
      },
      productsObj: null,
      fields: [
        { key: 'removeIcon', label: '' },
        { key: 'name', label: 'Product', thStyle: { width: '300px' } },
        { key: 'quantity', label: 'Quantity' },
        { key: 'price', label: 'Price' },
      ],
      items: [],
      subTotal: 0.00,
      vat: 0,
      total: 0.00,
      emailvariables: {
        debtiaReceipientsClient: 'debtia.userInvoiceClient',
      },
      templateVariables: [],
      // emailTemplate: '',
      // emailTemplateOptions: [],
      specialOptions: [
        { name: 'dato_felt', label: 'Select number of days after letter generation' },
        { name: 'auto_fik', label: '' },
        { name: 'debtia.recepient_name', label: 'Enter recepient name.' },
        { name: 'debtia.recepient_contact_person', label: 'Enter recepient contact person' },
        { name: 'debtia.recepient_road_name', label: 'Enter recepient address road name' },
        { name: 'debtia.recepient_house_number', label: 'Enter recepient house number' },
        { name: 'debtia.recepient_zipcode', label: 'Enter recepient zipcode' },
        { name: 'debtia.recepient_city', label: 'Enter recepient city' },
        { name: 'debtia.recepient_country', label: 'Enter recepient country' },
        { name: 'debtia.recepient_place', label: 'Enter recepient place' },
      ],
      communication_client_id: '',
      communication_secret: '',
      awaitPayment: true,
    }
  },
  created() {
    this.getProducts()
    this.getApiSettings()
  },
  methods: {
    async getApiSettings() {
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.communication_client_id = settings.data.data.client_id
          this.communication_secret = settings.data.data.secret
          this.getEmailTemplates()
        }
      })
    },
    assignClass(field) {
      let exists = false
      const entry = this.specialOptions.filter(e => e.name === field)
      // console.log('exists ', entry.length)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    changeVariable(event, variable) {
      this.$el.querySelector(`.email-template-${variable}`).classList.remove('inputErrorClass')
      if (event === 'dato_felt') {
        document.getElementById(`div-wrapper-${variable}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable}`).style.display = 'block'
        this.emailvariables[variable] = {
          variable: event,
          functional_value: 0,
        }
      } else {
        this.emailvariables[variable] = event
        document.getElementById(`div-wrapper-${variable}`).classList.remove('div-wrapper')
        document.getElementById(`date-${variable}`).style.display = 'none'
      }
      const emptyValues = this.templateVariables.filter(element => !this.emailvariables[element])
      if (emptyValues.length === 0) {
        this.errorMsg = false
      }
    },
    // changeTemplate() {
    //   this.busy = true
    //   this.templateVariables = []
    //   this.templateVariableOptions = []
    //   const url = `/template/get-template-vars-api/${this.emailTemplate}`
    //   const headers = {
    //     clientId: this.communication_client_id,
    //     secret: this.communication_secret,
    //   }
    //   axiosemail.get(url, {
    //     headers,
    //   }).then(response => {
    //     if (response.status === 200) {
    //       // console.log()
    //       setTimeout(() => {
    //         this.busy = false
    //         const object = response.data.data.template_custom_fields
    //         this.emailTemplateTitle = response.data.data.template.name
    //         // response.data.data.data.name
    //         object.forEach(element => {
    //           this.templateVariables.push(element.custom_field)
    //         })
    //         this.attachVariables()
    //       }, 2000)
    //     }
    //   })
    // },
    attachVariables() {
      this.templateVariableOptions = [
        { label: 'clients.name', value: 'clients.name' },
        { label: 'debtors.name', value: 'debtors.name' },
        { label: 'debtors.phone', value: 'debtors.phone' },
        { label: 'debtors.contact_person', value: 'debtors.contact_person' },
        { label: 'debtor_addresses.road_name', value: 'debtor_addresses.road_name' },
        { label: 'debtor_addresses.house_no', value: 'debtor_addresses.house_no' },
        { label: 'debtor_addresses.zip_code', value: 'debtor_addresses.zip_code' },
        { label: 'debtor_addresses.city', value: 'debtor_addresses.city' },
        { label: 'debt_case_info.payment_amount', value: 'debt_case_info.payment_amount' },
        { label: 'debt_case_info.interest_rate_percentage', value: 'debt_case_info.interest_rate_percentage' },
        { label: 'debt_case_info.reminder_fee', value: 'debt_case_info.reminder_fee' },
        { label: 'debt_case_info.paid_amount', value: 'debt_case_info.paid_amount' },
        { label: 'debt_case_info.credit_note_amount', value: 'debt_case_info.credit_note_amount' },
        { label: 'debt_case_info.total_amount', value: 'debt_case_info.total_amount' },
        { label: 'debt_cases.id', value: 'debt_cases.id' },
        { label: 'debtor.co', value: 'debtor.co' },
        { label: 'debtor.addresses.place', value: 'debtor.addresses.place' },
        { label: 'debt_case_info.principal', value: 'debt_case_info.principal' },
        { label: 'debt_case_info.remainingDebt', value: 'debt_case_info.remainingDebt' },
        { label: 'Await Days', value: 'await.days' },
        { label: 'Link', value: 'debtia.link' },
        { label: 'dato felt', value: 'dato_felt' },
        { label: 'Auto FIK', value: 'auto_fik' },
        { label: 'Recepient Name', value: 'debtia.recepient_name' },
        { label: 'Recepient Contact Person', value: 'debtia.recepient_contact_person' },
        { label: 'Recepient Address Road Name', value: 'debtia.recepient_road_name' },
        { label: 'Recepient Address House Number', value: 'debtia.recepient_house_number' },
        { label: 'Recepient Address Zipcode', value: 'debtia.recepient_zipcode' },
        { label: 'Recepient Address City', value: 'debtia.recepient_city' },
        { label: 'Recepient Address Country', value: 'debtia.recepient_country' },
        { label: 'Recepient Address Place', value: 'debtia.recepient_place' },
        { label: 'Invoice Details', value: 'invoiceDetails' },
      ]
    },
    // getEmailTemplates() {
    //   this.busy = true
    //   const url = '/email/get-templates'
    //   const headers = {
    //     clientId: this.communication_client_id,
    //     secret: this.communication_secret,
    //   }
    //   axiosemailv1.get(url, {
    //     headers,
    //   }).then(response => {
    //     if (response.status === 200) {
    //       const records = response.data.data
    //       records.forEach(element => {
    //         const elementObj = { label: element.name, value: element.id }
    //         this.emailTemplateOptions.push(elementObj)
    //       })
    //       setTimeout(() => {
    //         this.busy = false
    //       }, 2000)
    //     }
    //   })
    // },
    async getProducts() {
      this.busy = true
      const url = '/process/get-products'
      const getProducts = await axios.get(url).catch(e => e.response)
      if (getProducts.status !== 200) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: i18n.t('DEBTIA_SOMTHING_WENT_WRONG'),
          },
        })
        return false
      }
      this.productsObj = getProducts.data.data
      this.busy = false
      return true
    },
    getProductPrice(e, data) {
      const productID = data.item.name[e - 1].value
      const { index } = data
      const price = this.productsObj.filter(el => {
        if (el.id === productID) return el
        return null
      })
      this.items[index].price = price[0].price
      this.items[index].productName = price[0].name
      this.getSubTotal()
    },
    async submit() {
      // const emptyValues = this.templateVariables.filter(element => (!this.emailvariables[element] || (this.emailvariables[element] && this.emailvariables[element].functional_value === 0)))
      // if (emptyValues.length > 0) {
      //   emptyValues.forEach(element => {
      //     let selector = ''
      //     let classToPut = ''
      //     if (this.emailvariables[element] && this.emailvariables[element].functional_value === 0) {
      //       selector = `#noOfDays-${element}`
      //       classToPut = 'inputErrorClassField'
      //     } else {
      //       selector = `.email-template-${element}`
      //       classToPut = 'inputErrorClass'
      //     }
      //     this.$el.querySelector(selector).classList.add(classToPut)
      //   })
      //   this.errorMsg = true
      //   return false
      // }
      // if (this.total < 1 || !this.emailTemplate) {
      if (this.total < 1) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: i18n.t('DEBTIA_SELECT_PRODUCTS_TEMPLATE'),
          },
        })
        return false
      }
      this.busy = true
      const processID = this.$route.params.id
      // const emailTemplateId = this.emailTemplate
      // const emailTemplateVars = this.emailvariables
      const obj = {
        process_id: Number(processID),
        module_id: 8,
        subTotal: this.subTotal,
        vatAmount: this.vat,
        total: this.total,
        recipient: this.receipient,
        products: this.items,
        module_order: 1,
        awaitPayment: this.awaitPayment,
        // email_template_id: emailTemplateId,
        // custom_variables: emailTemplateVars,
      }
      if (this.conditionObject.moduleID > 0) {
        obj.depends_on = this.conditionObject.moduleID
        obj.condition = this.conditionObject.type
      }
      console.log('const ', obj)
      const response = await axios.post('/process/module/add', obj)
        .catch(e => e)
      if (response.status !== 200) {
        if (typeof response.response.data.message !== 'string') {
          response.response.data.message.forEach(element => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: element,
              },
            })
          })
          return false
        }
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: response.response.data.message,
          },
        })
        return false
      }
      this.items = []
      this.subTotal = 0
      this.vat = 0
      this.total = 0
      this.busy = false

      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Success',
          icon: 'CoffeeIcon',
          variant: 'success',
          text: i18n.t('DEBTIA_MODULE_ADDED_TEXT'),
        },
      })
      const returnObj = {
        parentID: this.conditionObject.parentID,
        depend: obj.depends_on,
      }
      returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
      this.$emit('closeReminderFeeModal', returnObj)

      return true
    },
    addProduct() {
      const products = {
        name: [],
        quantity: 1,
        price: 0.00,
        productId: 0,
        productName: null,
      }
      this.productsObj.forEach(element => {
        products.name.push({ label: element.name, value: element.id })
      })
      this.items.push(products)
    },
    getSubTotal() {
      this.subTotal = 0
      this.items.forEach(element => {
        this.subTotal += (element.quantity * element.price)
      })
      this.vat = this.subTotal * 0.25
      this.total = this.subTotal + this.vat
    },
    removeProduct(d) {
      this.items.splice(d.index, 1)
      this.getSubTotal()
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .emailSubmitBtn {
    width: 100%;
  }

  .inputErrorClass .vs__dropdown-toggle{
    border-color: red !important;
  }

  .inputErrorClassField{
    border-color: red !important;
  }

  #fieldserror {
    color: red;
  }

  .showdates {
    display: none;
    margin-top: 10px;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }

  div.div-wrapper {
    border: 1px solid #d8d6de;
    border-radius: 5px;
    padding: 10px 10px 0px 10px;
  }

  .left{
    float: left;
  }
  .right{
    float: right;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }
  #fieldserror {
    color: red;
  }

  .inputErrorClassField{
    border-color: red !important;
  }
</style>
